<template>
  <save-dialog
    title="Motivo de resolución"
    :show="showState"
    :form="form"
    :disableSaveBtn="disabledBtn"
    @changeValue="closeModal"
    @save="save">
    <template slot="content">
      <v-layout row wrap>
        <v-flex xs12>
          <v-select
            v-model="form.chat_category_id"
            :items="categories"
            item-value="id"
            item-text="name"
            v-validate="'required|numeric'"
            data-vv-name="chat_category_id"
            data-vv-as="Categoria"
            data-vv-scope="chatCenter"
            :error-messages="errors.collect('chatCenter.chat_category_id')"
            label="Categoria"
            color="black">
          </v-select>
        </v-flex>
      </v-layout>
      <v-layout row wrap v-if="categoryType && categoryType !== 'movement' && categoryType !== 'black_list' && categoryType !== 'unsolved'">
        <v-flex xs12>
          <v-text-field
            v-model="form.payment_promise_amount"
            v-validate="'required|decimal'"
            data-vv-name="promise-amount"
            data-vv-as="monto-compromiso"
            data-vv-scope="chatCenter"
            :error-messages="errors.collect('chatCenter.promise-amount')"
            key="more-amount-promise-field"
            label="Monto Compromiso"
            type="number"
            color="black"
            prefix="$">
          </v-text-field>
          <v-menu
            ref="datePicker"
            :close-on-content-click="false"
            :nudge-right="40"
            :return-value.sync="form.date"
            transition="scale-transition"
            min-width="290px"
            lazy
            offset-y
            full-width>
            <v-text-field
              slot="activator"
              v-model="dateFormatted"
              v-validate="`${categoryType !== 'movement' ? 'required' : null}`"
              data-vv-name="date"
              data-vv-scope="chatCenter"
              :data-vv-as="dateLabel.toLowerCase()"
              :error-messages="errors.collect('chatCenter.date')"
              key="movement-date-field"
              prepend-icon="event"
              :label="dateLabel"
              color="black"
              readonly>
            </v-text-field>
            <v-date-picker
              v-model="form.date"
              @input="$refs.datePicker.save(form.date)"
              locale="es"
              color="k-orange-linear">
            </v-date-picker>
          </v-menu>
        </v-flex>
      </v-layout>
      <v-layout row wrap v-if="more">
        <v-flex xs12>
          <v-text-field
            v-model="form.text"
            v-validate="'max:10000'"
            data-vv-name="text"
            data-vv-as="detalles"
            :error-messages="errors.collect('text')"
            key="more-text-field"
            label="Detalles"
            color="black">
          </v-text-field>
        </v-flex>
      </v-layout>
    </template>
  </save-dialog>
</template>

<script>
import { mapGetters } from 'vuex';
import SaveDialog from '@/components/global/SaveDialogV2';
import saveDialogMixin from '@/mixins/saveDialog';
import clearFormMixin from '@/mixins/clearForm';
import formatDateMixin from '@/mixins/formatDate';
import EventBus from '@/event-bus';

export default {
  inject: ['$validator'],
  components: {
    SaveDialog,
  },
  mixins: [
    saveDialogMixin,
    clearFormMixin,
    formatDateMixin,
  ],
  created() {
    this.axios.get('chat_categories?paginate=0').then((response) => {
      this.categories = response.data;
    }).catch(() => {});
    EventBus.$on('closeModal', () => {
      this.$store.commit('SET_SHOW', false);
    });
    EventBus.$on('update', () => {
      this.dialog = false;
    });
    EventBus.$on('markSolved', (event) => {
      this.$emit('mark-solved', { chatCenterId: this.chatCenterId, delete_chat: event.delete_chat, showAlert: event.showAlert });
    });
  },
  destroyed() {
    EventBus.$off('markSolved');
    EventBus.$off('openSolvedDialog');
    EventBus.$off('closeModal');
    EventBus.$off('update');
  },
  data() {
    return {
      dialog: false,
      categories: [],
      form: {
        chat_category_id: '',
        date: '',
        text: '',
        payment_promise_amount: 0,
      },
      more: true,
      cancelToken: this.axios.CancelToken.source(),
    };
  },
  computed: {
    ...mapGetters({
      chatCenterId: 'chatCenterId',
      showState: 'isShow',
      disabledButton: 'isDisable',
    }),
    route() {
      return `chats_center/${this.chatCenterId}/messages`;
    },
    categoryType() {
      return (this.categories.find(item => item.id === this.form.chat_category_id) || {}).type;
    },
    dateFormatted() {
      return this.formatDate(this.form.date, 'YYYY-MM-DD', 'DD/MM/YYYY');
    },
    dateLabel() {
      let label = 'Fecha de ';
      if (this.categoryType === 'payment_promise') {
        label += 'compromiso';
      } else {
        label += 'contacto';
      }
      return label;
    },
    disabledBtn() {
      return this.errors.any() || this.disabledButton;
    }
  },
  methods: {
    save() {
      this.$validator.validateAll('chatCenter').then((result) => {
        if (result) {
          this.$store.commit('SET_DISABLE', true);
          this.cancelToken.cancel('Canceled by user');
          this.cancelToken = this.axios.CancelToken.source();
          this.axios.post(this.route, this.form, {cancelToken: this.cancelToken.token}).then((response) => {
            if (response.data.id) {
              EventBus.$emit('created', response.data.id);
            } else if (response.data.chat_center_message) {
              EventBus.$emit('markSolved', response.data);
            }
            this.$store.commit('SET_DISABLE', false);
            this.$store.dispatch('CLOSE_SHOW_MODAL', false);
            EventBus.$emit('update');
          }).catch((error) => {
            this.$store.commit('SET_DISABLE', false);
            if (error.message === 'Canceled by user' || (error.response && error.response.status === 403)) {
              return;
            }
            // Mostrar en modal el mensaje del back (422: categoría obligatoria, asignar cliente, etc.)
            let messageToShow = 'Ocurrió un error al cerrar el chat. Intente nuevamente.';
            if (error.response && error.response.data) {
              const data = error.response.data;
              if (typeof data.message === 'string' && data.message) {
                messageToShow = data.message;
              } else if (data.data && data.data.errors && typeof data.data.errors === 'object') {
                const firstKey = Object.keys(data.data.errors)[0];
                const firstMsg = firstKey && data.data.errors[firstKey] && data.data.errors[firstKey][0];
                if (firstMsg) messageToShow = firstMsg;
              } else if (error.response.status === 418 && data) {
                messageToShow = typeof data === 'string' ? data : (data.message || messageToShow);
              }
            }
            EventBus.$emit('modal', messageToShow);
          });
        }
      });
    },
    closeModal() {
      this.$store.commit('SET_DISABLE', false);
      this.$store.dispatch('CLOSE_SHOW_MODAL', false);
    },
  },
  watch: {
    form: {
      deep: true,
      handler() {
        this.errors.clear();
        //this.$validator.reset();
      },
    },
    'form.chat_category_id'(newVal) { // eslint-disable-line
      Object.keys(this.form).forEach((key) => {
        if (key !== 'chat_category_id') {
          this.form[key] = '';
        }
      });
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/chat_center/SolvedDialog.vue